import { render, staticRenderFns } from "./SupplierPage.vue?vue&type=template&id=8b0233c8&scoped=true&"
import script from "./SupplierPage.vue?vue&type=script&lang=js&"
export * from "./SupplierPage.vue?vue&type=script&lang=js&"
import style0 from "./SupplierPage.vue?vue&type=style&index=0&id=8b0233c8&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8b0233c8",
  null
  
)

export default component.exports